import { AccountData } from '@types';
import { AccountDetailsTypeformActionButton } from './AccountDetailsTypeformActionButton';

// eslint-disable-next-line  @typescript-eslint/no-unsafe-assignment
const FORM_ID: string = (import.meta.env || process.env)
  ?.VITE_TYPEFORM_DOWNSELL;

export function DownsellButton({ clientData }: { clientData: AccountData }) {
  const hubspotId = (clientData.hubspot_id as string) || '';
  return (
    <AccountDetailsTypeformActionButton
      clientData={clientData}
      formId={FORM_ID}
      endpoint='clients/downsellSubmitted'
      buttonText='Downsell'
      buttonKey='downsell-button'
      errorMessage='There was an error saving the Downsell Notice. Try again or contact the system administrator.'
      extraHiddenProps={{ hubspot_id: hubspotId }}
    />
  );
}
